import { PlansPlanMode } from '../../../api/types'
import { PlansListErrorState } from '../../lumpsum-ui-components/PlansListErrorState'

type AllocationPlansListErrorStateProps = {
  onRetry: () => void
}

export function AllocationPlansListErrorState({ onRetry }: AllocationPlansListErrorStateProps) {
  return <PlansListErrorState planMode={PlansPlanMode.ALLOCATION} onRetry={onRetry} />
}
